import React, { useEffect, useState, useCallback } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import NeuralBackground from './components/NeuralBackground'
import About from './sections/About'
import Experience from './sections/Experience'
import Projects from './sections/Projects'
import Expertise from './sections/Expertise'
import Impact from './sections/Impact'
import Contact from './sections/Contact'
import Footer from './components/Footer'

function App() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Disable right-click on images
  useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault()
        return false
      }
    }
    
    // Disable drag on images
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault()
        return false
      }
    }
    
    // Disable keyboard shortcuts for saving
    const handleKeyDown = (e) => {
      // Ctrl+S, Ctrl+U, Ctrl+Shift+I
      if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'u')) {
        e.preventDefault()
        return false
      }
    }
    
    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('dragstart', handleDragStart)
    document.addEventListener('keydown', handleKeyDown)
    
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('dragstart', handleDragStart)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <div className="relative min-h-screen bg-dark overflow-x-hidden">
      <NeuralBackground />
      <Navbar scrolled={scrolled} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Expertise />
        <Impact />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App
